var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSDiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5567_107)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2665 3.7334V14.9307H78.1745V3.7334H80.2665Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2265 12.0496L69.3754 14.9336H67.2L70.8491 3.73633H73.3671L76.9999 14.9336H74.7131L73.8593 12.0552H70.2265V12.0496ZM73.4299 10.4036L72.0975 5.87598H72.0051L70.6727 10.4036H73.4299Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5V60.375V74.1333C0 79.5825 4.41747 84 9.86668 84H71.8846C75.0978 84 78.1794 82.8938 80.4515 80.9246C82.7236 78.9555 84 76.2848 84 73.5V18.6667H77.9423H66.7556C64.9392 18.6667 63.4667 17.1942 63.4667 15.3778V0H12.1154C8.90218 0 5.82059 1.10625 3.54852 3.07538C1.27644 5.04451 0 7.71523 0 10.5Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7461 41.624C46.7461 44.344 46.2361 46.622 45.2161 48.458C44.2187 50.294 42.7794 51.6767 40.8981 52.606C39.0167 53.5353 36.7387 54 34.0641 54H27.2981V29.724H34.7781C37.2261 29.724 39.3454 30.1773 41.1361 31.084C42.9267 31.9907 44.3094 33.328 45.2841 35.096C46.2587 36.8413 46.7461 39.0173 46.7461 41.624ZM43.5161 41.726C43.5161 39.5727 43.1534 37.8047 42.4281 36.422C41.7254 35.0393 40.6827 34.0193 39.3001 33.362C37.9401 32.682 36.2854 32.342 34.3361 32.342H30.3581V51.382H33.6561C36.9427 51.382 39.4021 50.5773 41.0341 48.968C42.6887 47.336 43.5161 44.922 43.5161 41.726ZM58.968 54H50.196V52.232L53.052 51.586V32.172L50.196 31.492V29.724H58.968V31.492L56.112 32.172V51.586L58.968 52.232V54Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5567_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSDiLogo);
export default __webpack_public_path__ + "static/media/S_DI_Logo.b6c04d9ee01d098e3edb212491e931f1.svg";
export { ForwardRef as ReactComponent };